var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: "splashPageMobileVueModal",
    style: _vm.modalStyles,
    attrs: {
      "name": "splashPageModal",
      "click-to-close": false,
      "show-close-icon": true,
      "height": "100%",
      "width": "100%",
      "classes": ['splash-page-modal', 'v--modal'],
      "scrollable": false
    },
    on: {
      "before-open": _vm.beforeOpen,
      "opened": _vm.opened,
      "before-close": _vm.beforeClose,
      "closed": _vm.closed
    }
  }, [_c('section', {
    staticClass: "splash-page-modal-wrapper"
  }, [_c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isLoading,
      expression: "isLoading"
    }],
    attrs: {
      "classes": "spinner",
      "position": "absolute"
    }
  }), _c(_vm.splashPageComponent, {
    ref: _vm.splashPageComponent,
    tag: "component",
    attrs: {
      "is-touch-started": _vm.istouchStarted,
      "is-loading": _vm.isLoading
    },
    on: {
      "restoreModel3D": _vm.restoreModel3D
    }
  }, [[!_vm.editorVisible ? _c('div', {
    staticClass: "model-3d",
    attrs: {
      "id": "model3d"
    }
  }) : _vm._e()]], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }